module.exports = __webpack_public_path__ + "img/16_maska_klen.9191271.svg";